import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import seo from './restaurant-seo.json';

export default function Seo() {
    const { pathname } = useLocation();
    useEffect(() => {
        const home = pathname === '/';
        const title = home ? seo.title : `${/^\/(connexion|panel)\/?$/i.test(pathname) ? 'Administration' : 'Page introuvable'} | À l’Exotique`;
        document.title = title;
        const meta = (key, value, property = false) => {
            const attribute = property ? 'property' : 'name';
            let element = document.head.querySelector(`meta[${attribute}="${key}"]`);
            if (!element) {
                element = document.createElement('meta');
                element.setAttribute(attribute, key);
                document.head.appendChild(element);
            }
            element.content = value;
        };
        meta('robots', home ? 'index, follow, max-image-preview:large' : 'noindex, follow');
        meta('description', home ? seo.description : 'À l’Exotique, restaurant thaïlandais à Morrens.');
        meta('og:title', title, true);
        meta('twitter:title', title);
        meta('og:description', home ? seo.description : '', true);
        meta('twitter:description', home ? seo.description : '');
        let canonical = document.head.querySelector('link[rel="canonical"]');
        let schema = document.getElementById('restaurant-schema');
        if (home) {
            if (!canonical) {
                canonical = document.createElement('link');
                canonical.rel = 'canonical';
                document.head.appendChild(canonical);
            }
            canonical.href = `${seo.origin}/`;
            meta('og:url', `${seo.origin}/`, true);
            if (!schema) {
                schema = document.createElement('script');
                schema.id = 'restaurant-schema';
                schema.type = 'application/ld+json';
                document.head.appendChild(schema);
            }
            schema.textContent = JSON.stringify(seo.restaurant);
        } else {
            canonical?.remove();
            schema?.remove();
            document.head.querySelector('meta[property="og:url"]')?.remove();
        }
    }, [pathname]);
    return null;
}
